let getters = require('../vuex/getters')

module.exports = {

  getCourseById : (series_id, course_id) => {
    let serieses = getters.getSerieses

    let seriesIndex = _.findIndex(serieses, { id: parseInt(series_id) })

    if (seriesIndex == -1) return null

    let series = serieses[seriesIndex]

    //if (series == undefined) return null
    // console.log(series)

    let courseIndex = _.findIndex(series.courses, { id: parseInt(course_id) })

    if (courseIndex == -1) return null

    let course = series.courses[courseIndex]

    //if (course == undefined) return null

    return course
  }
}



// WEBPACK FOOTER //
// ./src/methods/CourseMethods.js